/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { ModelDeduction } from 'account-client'
import dayjs from 'dayjs'
import { useTranslateAmount } from '@/hooks/useTranslateAmount'
import { timeFormatter } from '@/utils/timeFormatter'

export function useVoucherRedeemedRecordsColumns() {
  const { t } = useTranslation()
  const { contractId } = useParams()
  const { currency } = useTranslateAmount()

  const columns = useMemo<TableColumnsType<ModelDeduction>>(() => {
    return [
      {
        title: t('Redeemed on'),
        dataIndex: 'gmtCreated',
        sorter: true,
        width: 180,
        render: value => timeFormatter.format(value),
      },
      {
        title: t('Voucher ID'),
        dataIndex: 'voucherID',
      },
      {
        title: `${t('Redeemed Amount')}（${currency}）`,
        dataIndex: 'voucherDeductedFormatted',
      },
      {
        title: `${t('Voucher Balance')}（${currency}）`,
        dataIndex: 'voucherNewBalanceFormatted',
      },
      {
        title: t('Related Statement'),
        render: record => (
          <Link to={`/billing-center/${contractId}/statements/${record.statementID}`}>
            {timeFormatter.format(record.statementStart, 'yearMonth')}
          </Link>
        ),
      },
    ]
  }, [])

  return columns
}
